import React from 'react';
import { Icon, Icons } from '@silverfort/sf-components';

const ImportFromFileButton = ({ onFileUploaded, fileLoading, error }) => {
    const componentId = `ImportFromFileButton`;

    return (
        <div
            className={`flex items-center pl-1 pr-2 border border-gray-300 cursor-pointer rounded h-6 flex-1 hover:border-sf-primary-500 ${
                error ? 'border-sf-error' : ''
            }`}>
            <label htmlFor={componentId} className="text-sf-primary-500 flex cursor-pointer items-center mb-0">
                <Icon className="text-sf-primary-500" icon={fileLoading ? Icons.Loader : Icons.Upload} />
                <div className="text-13 font-medium mx-1 font-sf">Upload file</div>
            </label>

            <input
                type="file"
                id={componentId}
                accept=".csv"
                multiple={false}
                disabled={fileLoading}
                onChange={(e) => {
                    onFileUploaded(e.target.files[0]);
                }}
                onClick={(e) => {
                    e.target.value = null;
                }}
                className="hidden"
            />
        </div>
    );
};

export default ImportFromFileButton;
